define('app/views/tooltip_view',['app/setup'], function(takhfifan) {
  takhfifan.TooltipView = Backbone.View.extend({
    events: {
      'click': 'toggle'
    },

    initialize: function () {
      var $el = this.$el;

      $(document).on('click.tooltip', function(e){
        if(!$(e.target).hasClass('tooltip--active') && $el.hasClass('tooltip--active')) {
          $el.removeClass('tooltip--active');
        }
      })
    },

    toggle: function () {
      this.$el.toggleClass('tooltip--active');
    }
  })
});

